import styled from 'react-emotion';
import { themeGet } from 'styled-system';
import { ActionButton } from '../buttons';

// @flex
// @box-shadow
export const Wrapper = styled('div')`
  display: flex;
  align-items: stretch;
  position: relative;
  border-radius: 4px;
  box-shadow: 0 0 0.25rem 0 hsla(0, 1%, 74%, 0.5);
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    color: ${themeGet('colors.indigo')};
    background-color: ${themeGet('colors.greyLighter')};
  }
`;

export const ManipulationButton = styled('button')`
  font-weight: 400;
  background-color: #fff;
  border: 0;
  outline: none;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.15s linear;
  color: ${themeGet('colors.indigoLight')};
  &:hover {
    background-color: ${themeGet('colors.indigoLight')};
    color: #fff;
    border-top-right-radius: ${props => (props.left ? 0 : '4px')};
    border-bottom-right-radius: ${props => (props.left ? 0 : '4px')};
    border-top-left-radius: ${props => (props.right ? 0 : '4px')};
    border-bottom-left-radius: ${props => (props.right ? 0 : '4px')};
  }
`;

export const AddActionButton = styled(ActionButton)`
  border: 1px solid ${themeGet('colors.indigoLight')};
  color: ${themeGet('colors.indigo')};
  text-transform: none;
  background-color: #fff;
  font-weight: 400;
  padding: ${themeGet('space.2')}px ${themeGet('space.4')}px;
  svg {
    fill: ${themeGet('colors.indigo')};
  }
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 7px 14px rgba(50, 50, 93, 0.11), 0 3px 6px rgba(0, 0, 0, 0.08);
    background-color: ${themeGet('colors.indigoLight')};
    color: #fff;
    svg {
      fill: #fff;
    }
  }
  span {
    padding-right: 4px;
  }
  span:last-child {
    padding-left: 4px;
    padding-right: 0;
  }
`;

export const PlaceHolder = styled('div')`
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 1px;
`;



// WEBPACK FOOTER //
// ../shop_main/components/qtymanipulator/style.js